export interface VoiceLink {
  projectId: number;
  conversationId?: string;
  /** What a voice check-in reminder is about. The server checks it against its own list. */
  checkin?: string;
}

/** A link to Ellie voice: /project/123/voice, then a conversation id or ?checkin=blood_pressure. */
export function parseVoiceLink(url: string | null | undefined): VoiceLink | null {
  if (!url) return null;
  const m = url.match(/\/project\/(\d+)\/voice(?:\/([0-9a-fA-F-]{36}))?(?:[/?#]|$)/);
  if (!m) return null;
  return {
    projectId: parseInt(m[1], 10),
    conversationId: m[2] || undefined,
    checkin: url.match(/[?&]checkin=([a-z_]+)/)?.[1],
  };
}
